import { Input as I } from './Input';
import { PhoneInput } from './PhoneInput';
import { SearchInput } from './SearchInput';

export const Input = Object.assign(I, {
  Phone: PhoneInput,
  Search: SearchInput,
});

